export default __webpack_public_path__ + "images/cf7f2225951c5545660931fa385e8848-EE_SlideDeckBOOK1024_5.png";